module.exports = __webpack_public_path__ + "img/icon_performance_no_data.svg";